import { useEffect } from 'react';

/**
 * ScrollFix Component
 * Enforces single scrollbar on mobile by removing all parent scrollbars
 */
const ScrollFix = () => {
  useEffect(() => {
    // Function to fix scrollbars
    const fixScrollbars = () => {
      // Get all elements that might have scrollbars
      const elements = document.querySelectorAll('*');
      
      elements.forEach(el => {
        const styles = window.getComputedStyle(el);
        const inlineStyle = el.getAttribute('style') || '';
        
        // Skip if it's the cards container or a tab navigation container
        if (el.classList.contains('v4-cards-container') || 
            inlineStyle.includes('overflowX: auto')) {
          return;
        }
        
        // If element has vertical overflow auto or scroll
        if (styles.overflowY === 'auto' || styles.overflowY === 'scroll') {
          // Force it to visible
          el.style.overflowY = 'visible';
          console.log('Fixed vertical scrollbar on:', el.className || el.tagName);
        }
      });

      // Ensure only cards container can scroll
      const cardsContainer = document.querySelector('.v4-cards-container');
      if (cardsContainer) {
        cardsContainer.style.overflowY = 'auto';
        cardsContainer.style.overflowX = 'hidden';
      }
    };

    // Fix on mount
    fixScrollbars();

    // Fix on any DOM changes
    const observer = new MutationObserver(fixScrollbars);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });

    return () => observer.disconnect();
  }, []);

  return null;
};

export default ScrollFix;
